import { Icon } from "../../../components";
import { BadgeGreen } from "../../../components/badge/Badge";
import { TooltipContainer } from "@sellar-io/components";

type SellarCreditPaymentStatusIndicatorProps = {
  invoicePaidAt: Date | null;
  isDirector: boolean;
  userType: "supplier" | "buyer";
};

export const SellarCreditPaymentStatusIndicator = ({
  userType,
  ...props
}: SellarCreditPaymentStatusIndicatorProps) => {
  if (userType === "buyer") {
    return <SellarCreditPaymentStatusIndicatorBuyer {...props} />;
  }

  if (userType === "supplier") {
    return <SellarCreditPaymentStatusIndicatorSupplier {...props} />;
  }

  return null;
};

const SellarCreditPaymentStatusIndicatorBuyer = ({
  invoicePaidAt,
  isDirector,
}: Omit<SellarCreditPaymentStatusIndicatorProps, "userType">) => {
  if (invoicePaidAt && !isDirector) {
    return (
      <TooltipContainer enable={true} text="Invoice paid">
        <BadgeGreen icon="FILE_DOCUMENT_CHECK_OUTLINE">
          <span>Invoice paid</span>
          <Icon icon="CHEVRON_RIGHT" size={0.7} />
        </BadgeGreen>
      </TooltipContainer>
    );
  }

  if (invoicePaidAt && isDirector) {
    return (
      <TooltipContainer enable={true} text="Invoice paid">
        <BadgeGreen icon="FILE_DOCUMENT_CHECK_OUTLINE">
          <a href="#orderDocuments" className="hover:underline">
            Invoice paid
          </a>
          <Icon icon="CHEVRON_RIGHT" size={0.7} />
        </BadgeGreen>
      </TooltipContainer>
    );
  }
  return null;
};

const SellarCreditPaymentStatusIndicatorSupplier = ({
  invoicePaidAt,
}: Omit<SellarCreditPaymentStatusIndicatorProps, "userType">) => {
  if (invoicePaidAt) {
    return (
      <TooltipContainer enable={true} text="Invoice paid">
        <BadgeGreen icon="FILE_DOCUMENT_CHECK_OUTLINE">
          <a href="#orderDocuments" className="hover:underline">
            Invoice paid
          </a>
          <Icon icon="CHEVRON_RIGHT" size={0.7} />
        </BadgeGreen>
      </TooltipContainer>
    );
  }
  return null;
};
